import { call, put, select as selectState, takeLatest } from "redux-saga/effects";
import {
  onBusinessUpdate,
  onBusinessUpdateError,
  onBusinessUpdateSuccess,
  onGetBusiness,
  onGetBusinessError,
  onGetBusinesses,
  onGetBusinessesError,
  onGetBusinessesSuccess,
  onGetBusinessSuccess,
} from "../Store/Slices/businessSlice";
import {
  callBusinessUpdateApi,
  callGetBusinessApi,
} from "../Context/businessApi";
import { callGetBusinessesApi } from "../Context/adminApi";

function* businessUpdateSaga({ payload }) {
  try {
    const response = yield call(callBusinessUpdateApi, payload);
    if (response.httpStatusCode === "200" || response.httpStatusCode === 200) {
      yield put(
        onBusinessUpdateSuccess({
          data: response.data,
          message: response.message,
          status_code: response.httpStatusCode,
        }),
      );
    } else {
      yield put(
        onBusinessUpdateError({
          data: response.data || null,
          message: response.message || "Update failed",
          status_code: response.httpStatusCode,
        }),
      );
    }
  } catch (error) {
    const message =
      error.response?.data?.message || error.message || "Something went wrong";
    yield put(onBusinessUpdateError({ data: null, message, status_code: 400 }));
  }
}

function* getBusinessSaga({ payload }) {
  try {
    const response = yield call(callGetBusinessApi, payload);
    if (response.httpStatusCode === "200" || response.httpStatusCode === 200) {
      const business = response.data?.business ?? response.data;
      yield put(
        onGetBusinessSuccess({
          data: business,
          message: response.message,
          status_code: response.httpStatusCode,
        }),
      );
    } else {
      yield put(
        onGetBusinessError({
          data: response.data || null,
          message: response.message || "Failed to fetch business",
          status_code: response.httpStatusCode,
        }),
      );
    }
  } catch (error) {
    const message =
      error.response?.data?.message || error.message || "Something went wrong";
    yield put(onGetBusinessError({ data: null, message, status_code: 400 }));
  }
}

function* getBusinessesSaga({ payload }) {
  try {
    const { append, ...apiParams } = payload || {};
    if (!apiParams.all) {
      let city =
        apiParams.city != null && String(apiParams.city).trim()
          ? String(apiParams.city).trim()
          : "";
      if (!city) {
        const selectedCity = yield selectState(
          (state) => state.utilityReducer?.selectedCity ?? "",
        );
        city =
          selectedCity && String(selectedCity).trim()
            ? String(selectedCity).trim()
            : "";
      }
      if (city) {
        apiParams.city = city;
      } else {
        delete apiParams.city;
      }
    }
    const response = yield call(callGetBusinessesApi, apiParams);
    if (response?.httpStatusCode === "200") {
      yield put(
        onGetBusinessesSuccess({
          data: response?.data,
          message: response?.message,
          status_code: response?.httpStatusCode,
          append: Boolean(append),
          total: response?.data?.total ?? response?.total,
        })
      );
    } else {
      yield put(
        onGetBusinessesError({
          message: response?.message ?? "Failed to load businesses",
        })
      );
    }
  } catch (error) {
    const message =
      error?.response?.data?.message ??
      error?.message ??
      "Failed to load businesses";
    yield put(onGetBusinessesError({ message }));
  }
}

export default function* businessSaga() {
  yield takeLatest(onBusinessUpdate.type, businessUpdateSaga);
  yield takeLatest(onGetBusiness.type, getBusinessSaga);
  yield takeLatest(onGetBusinesses.type, getBusinessesSaga);
}
